export default __webpack_public_path__ + "static/media/services1.a5d0cb66.jpg";